import { createReducer, on } from '@ngrx/store';
import {
  clearUnitTrustTransactions,
  fetchUnitTrustAccounts,
  fetchUnitTrustAccountsFailure,
  fetchUnitTrustAccountsSuccess,
  fetchUnitTrustAccountTransactions,
  fetchUnitTrustAccountTransactionsFailure,
  fetchUnitTrustAccountTransactionsSuccess,
  fetchUnitTrustFactSheets,
  fetchUnitTrustFactSheetsFailure,
  fetchUnitTrustFactSheetsSuccess,
  getSavingsAccountParamsFailure,
  getSavingsAccountParamsSuccess,
  getUnitTrustAccountStatementFailure,
  getUnitTrustAccountStatementSuccess,
  openUnitTrustFundAccountFailure,
  openUnitTrustFundAccountSuccess,
  openSavingsAccountFailure,
  openSavingsAccountSuccess,
  withdrawFromUnitTrustAccountFailure,
  withdrawFromUnitTrustAccountSuccess
} from './actions';

export const UNIT_TRUST_ACCOUNT_STATEMENT_FEATURE_KEY = 'unitTrustAccountStatement';
export const UNIT_TRUST_ACCOUNT_ACCOUNTS_KEY = 'unitTrustAccounts';
export const UNIT_TRUST_ACCOUNT_ACCOUNT_TRANSACTIONS_KEY = 'unitTrustAccountTransactions';
export const SAVINGS_ACCOUNT_PARAMS_FEATURE_KEY = 'savingsAccountParams';
export const UNIT_TRUST_FACT_SHEETS_KEY = 'unitTrustFactSheets';
export const OPEN_UNIT_TRUST_ACCOUNT_FEATURE_KEY = 'openUnitTrustAccount';

/**
 * Open Savings Account
*/
export interface OpenSavingsAccountState {
  error: any;
  accountDetails: any[];
}

export const initialOpenSavingsAccountState: OpenSavingsAccountState = {
  error: null,
  accountDetails: [],
};

export const openSavingsAccountReducer = createReducer(
  initialOpenSavingsAccountState,
  on(openSavingsAccountSuccess, (state: any, action: any) => {
    return {
      ...state,
      accountDetails: [...state.accountDetails, { ...action.accountDetails }],
    };
  }),
  on(openSavingsAccountFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);


/**
 * Open Unit Trust Account
*/
export interface OpenUnitTrustAccountState {
  error: any;
  accountDetails: any[];
}

export const initialOpenUnitTrustAccountState: OpenUnitTrustAccountState = {
  error: null,
  accountDetails: [],
};

export const openUnitTrustAccountReducer = createReducer(
  initialOpenUnitTrustAccountState,
  on(openUnitTrustFundAccountSuccess, (state: any, action: any) => {
    return {
      ...state,
      accountDetails: [...state.accountDetails, { ...action.accountDetails }],
      error: null,
    };
  }),
  on(openUnitTrustFundAccountFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Get unit trust statement
*/
export interface GetUnitTrustAccountStatementState {
  error: any;
  statement: any[];
}

export const initialGetUnitTrustAccountStatementState: GetUnitTrustAccountStatementState = {
  error: null,
  statement: [],
};

export const getUnitTrustAccountStatementReducer = createReducer(
  initialGetUnitTrustAccountStatementState,
  on(getUnitTrustAccountStatementSuccess, (state: any, action: any) => {
    return {
      ...state,
      statement: [...state.statement, { ...action.statement }],
    };
  }),
  on(getUnitTrustAccountStatementFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Withdraw from Unit Trust Account
*/
export interface WithdrawFromUnitTrustAccountState {
  error: any;
  accountDetails: any[];
}

export const initialWithdrawFromUnitTrustAccountState: WithdrawFromUnitTrustAccountState = {
  error: null,
  accountDetails: [],
};

export const withdrawFromUnitTrustAccountReducer = createReducer(
  initialWithdrawFromUnitTrustAccountState,
  on(withdrawFromUnitTrustAccountSuccess, (state: any, action: any) => {
    return {
      ...state,
      accountDetails: [...state.accountDetails, { ...action.accountDetails }],
    };
  }),
  on(withdrawFromUnitTrustAccountFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Fetch unit trust accounts
 */
export interface UnitTrustAccountState {
  error: any;
  accounts: any[];
}

export const initialUnitTrustAccountsState: UnitTrustAccountState = {
  error: null,
  accounts: [],
};

export const unitTrustAccountsReducer = createReducer(
  initialUnitTrustAccountsState,
  on(fetchUnitTrustAccounts, (state: any) => {
    return {
      ...state,
      accounts: [...state.accounts],
    };
  }),

  on(fetchUnitTrustAccountsSuccess, (state: any, action: any) => {
    return {
      ...state,
      accounts: action.accounts,
    };
  }),

  on(fetchUnitTrustAccountsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
)

/**
 * Fetch unit trust account transactions
 */
export interface UnitTrustAccountTransactionsState {
  error: any;
  transactions: any[];
}

export const initialUnitTrustAccountTransactionsState: UnitTrustAccountTransactionsState = {
  error: null,
  transactions: [],
};

export const unitTrustAccountTransactionsReducer = createReducer(
  initialUnitTrustAccountTransactionsState,
  on(fetchUnitTrustAccountTransactions, (state: any) => {
    return {
      ...state,
      transactions: [...state.transactions],
    };
  }),

  on(fetchUnitTrustAccountTransactionsSuccess, (state: any, action: any) => {
    return {
      ...state,
      transactions: action.transactions,
    };
  }),

  on(clearUnitTrustTransactions, (state) => ({
    ...state,
    transactions: [],
    error: null
  })),

  on(fetchUnitTrustAccountTransactionsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
)

/**
 * Get Savings Account Params
*/
export interface GetSavingsAccountParamsState {
  error: any;
  savingsAccountParams: any;
}

export const initialGetSavingsAccountParamsState: GetSavingsAccountParamsState = {
  error: null,
  savingsAccountParams: null,
};

export const getSavingsAccountParamsReducer = createReducer(
  initialGetSavingsAccountParamsState,
  on(getSavingsAccountParamsSuccess, (state: any, action: any) => {
    return {
      ...state,
      savingsAccountParams: action.savingsAccountParams,
    };
  }),
  on(getSavingsAccountParamsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Fetch unit trust fact sheets
 */
export interface UnitTrustFactSheetsState {
  error: any;
  factSheets: any[];
  loading: boolean;
}

export const initialUnitTrustFactSheetsState: UnitTrustFactSheetsState = {
  error: null,
  factSheets: [],
  loading: false,
};

export const unitTrustFactSheetsReducer = createReducer(
  initialUnitTrustFactSheetsState,
  on(fetchUnitTrustFactSheets, (state: any) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),

  on(fetchUnitTrustFactSheetsSuccess, (state: any, action: any) => {
    return {
      ...state,
      loading: false,
      factSheets: action.factSheets,
    };
  }),

  on(fetchUnitTrustFactSheetsFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  })
);
